// removed by extract-text-webpack-plugin
module.exports = {"App":"-App-App-1o-Fpb-","App-logo":"-App-App-logo-3JCPtt-","App-logo-spin":"-App-App-logo-spin-RvI1Jd-","App-header":"-App-App-header-3iH8Lj-","App-title":"-App-App-title-EIoWqr-","App-intro":"-App-App-intro-1OgPcC-"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 643
// module chunks = 0